export default __webpack_public_path__ + "static/2-a440a4e9c003306e6c98305f9153591e.png";